import { v4 as uuidv4 } from "uuid";
import {
  TranslatableEntity,
  TranslatableEntityProps,
} from "../../shared/domain/TranslatableEntity";

export interface CreateLoyaltyTagProps extends TranslatableEntityProps {
  ticker: string;
  type: LoyaltyTagType;
  icon?: string;
}

export interface LoyaltyTagProps extends CreateLoyaltyTagProps {
  id: string;
}

export enum LoyaltyTagType {
  PREFERENCE = "PREFERENCE",
}

export class LoyaltyTag extends TranslatableEntity {
  readonly id: string;
  readonly ticker: string;
  readonly type: LoyaltyTagType;
  readonly icon?: string;

  private constructor(props: LoyaltyTagProps) {
    super(props);
    this.id = props.id;
    this.ticker = props.ticker;
    this.type = props.type;
    this.icon = props.icon;
  }

  static of(props: LoyaltyTagProps): LoyaltyTag {
    return new LoyaltyTag(props);
  }

  static create(props: CreateLoyaltyTagProps): LoyaltyTag {
    return new LoyaltyTag({
      id: uuidv4(),
      ...props,
    });
  }
}
